module.exports = __webpack_public_path__ + "img/ic24Location.959bf50f.svg";